export default __webpack_public_path__ + "static/media/doc.2cb6a9ee.svg";